export const defaultConfig = {
    // baseAPIUrl:"https://laravel9.etrueconcept.com/aliskebab/api/"
     baseAPIUrl:"https://alis-kebab.com/backend/api/"
    //baseAPIUrl:"http://192.168.0.48/alis_kebab/api/"
    };